import { GetTypesBatchByFeaturesResponse } from 'framework-builder-read-service-client/FrameworkBuilderReadService/types';
import { AppSettingTypeMap } from './AppSettingTypeMap';

export const keyEntriesByAppSettings = (
  entries: GetTypesBatchByFeaturesResponse
) => {
  return Object.entries(entries).reduce(
    (mappedEntries, [fullyQualifiedName, appSettings]) => {
      Object.entries(appSettings).forEach(([appSettingName, metadata]) => {
        if (!mappedEntries[appSettingName]) {
          mappedEntries[appSettingName] = {};
        }

        if (!mappedEntries[appSettingName][fullyQualifiedName]) {
          mappedEntries[appSettingName][fullyQualifiedName] = metadata;
        }
      });

      return mappedEntries;
    },
    {} as AppSettingTypeMap
  );
};

export const keyEntriesByFQN = (entries: AppSettingTypeMap) => {
  return Object.entries(entries).reduce(
    (mappedEntries, [appSettingName, typeEntries]) => {
      Object.entries(typeEntries).forEach(([fullyQualifiedName, metadata]) => {
        if (!mappedEntries[fullyQualifiedName]) {
          mappedEntries[fullyQualifiedName] = {};
        }

        if (!mappedEntries[fullyQualifiedName][appSettingName]) {
          mappedEntries[fullyQualifiedName][appSettingName] = metadata;
        }
      });

      return mappedEntries;
    },
    {} as GetTypesBatchByFeaturesResponse
  );
};

export const recombineAppSettingTypeMap = (
  results: PromiseSettledResult<AppSettingTypeMap[string] | null>[],
  appSettingNames: string[]
) => {
  const combinedAppSettings: AppSettingTypeMap = {};

  for (const [index, appSettingName] of appSettingNames.entries()) {
    const result = results[index];

    if (result.status === 'fulfilled' && result.value) {
      combinedAppSettings[appSettingName] = result.value;
    }
  }

  return combinedAppSettings;
};
